
import { FormField, FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Control } from "react-hook-form";
import { EntryFormValues } from "./EntryEditDialog";

interface EntryTextFieldsProps {
  control: Control<EntryFormValues>;
}

const EntryTextFields = ({ control }: EntryTextFieldsProps) => {
  return (
    <>
      <FormField
        control={control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Title</FormLabel>
            <FormControl>
              <Input 
                {...field} 
                placeholder="Enter a title for your diary entry..."
              />
            </FormControl>
          </FormItem>
        )}
      />
      
      <FormField
        control={control}
        name="entryText"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Diary Entry</FormLabel>
            <FormControl>
              <Textarea 
                {...field} 
                className="min-h-[200px]" 
                placeholder="Write your diary entry..."
              />
            </FormControl>
          </FormItem>
        )}
      />
    </>
  );
};

export default EntryTextFields;
